import RouteTemplate from 'ember-route-template';
import ServiceUnavailable from 'garaje/components/service-unavailable';

export default RouteTemplate<{ Args: { model: unknown } }>(
  <template><ServiceUnavailable @error={{@model}} /></template>,
);
